.handle {
  cursor: grab;
  touch-action: none;
  display: inline-flex;
  align-items: center;
  padding: 4px;
}

.handle:active {
  cursor: grabbing;
}
